import { ApolloClientProfile } from '@syconium/weeping-figs'

import { PrimaryNavWelcomeDialog } from '../../../app/_components/chrome/PrimaryNavWelcome.client'
import { useCartRecovery } from '../../../app/_hooks/useCartRecovery'
import { MiniCartAndOverlay } from '../../../brunswick/components/MiniCartAndOverlay'
import { FETCH_SITE_FIXTURES } from '../../../lib/graphql/queries/FETCH_SITE_FIXTURES'
import { singleQueryParamValue } from '../../../lib/routing'
import { UnsupportedBanner } from '../../chrome/UnsupportedBanner'
import { NavFooter } from '../../nav/NavFooter'
import { NavHeader } from '../../nav/NavHeader'
import { PromoBarFromContext } from '../../nav/PromoBar'
import { SkipToMainContentLink } from '../../nav/SkipToMainContentLink'
import { SearchOverlay } from '../../pages/search/Search/SearchOverlay'
import { PageLayoutConfig } from '../types'

interface PrimaryLayoutProps {
  children?: React.ReactNode
}

function PrimaryLayout({ children }: PrimaryLayoutProps) {
  useCartRecovery()

  return (
    <>
      <SkipToMainContentLink />

      <UnsupportedBanner />

      <SearchOverlay />

      <PromoBarFromContext />

      <NavHeader />

      <>{children}</>

      <NavFooter />

      <PrimaryNavWelcomeDialog />

      <MiniCartAndOverlay />

      {/* NOTE: this will be used with some future A/B tests, commenting out for now to reduce queries. - Ryan B (12/02/2025) */}
      {/* <CartInterstitialAndOverlay /> */}
    </>
  )
}

export const primaryLayoutConfig: PageLayoutConfig = {
  Layout: ({ content, options: _options }) => <PrimaryLayout>{content}</PrimaryLayout>,
  preloadDataForLayout: pageContext => {
    const content: string = singleQueryParamValue(pageContext.query.content)
    const contentClient = pageContext.apolloClientFactory.for(
      ApolloClientProfile.FigsPublicSupergraph
    )

    return contentClient.query({
      query: FETCH_SITE_FIXTURES,
      variables: { handle: 'default', preview: content === 'preview' },
    })
  },
}
